function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel';
import { getFormData } from './recommendation.utils';
var SKIP_DEBUG = true;
export var RecommendationComponent = /*#__PURE__*/function (_lm$Composant) {
  /**
   * Constructor of the RecommendationComponent class.
   * The child class should call super(section) in its constructor.
   * The constructor should not do any side effect action.
   * @param {HTMLDivElement} htmlSection
   */
  function RecommendationComponent(htmlSection) {
    var _this;
    _classCallCheck(this, RecommendationComponent);
    _this = _callSuper(this, RecommendationComponent, [htmlSection.id.replace('component-', '')]);
    _this.section = htmlSection;
    return _this;
  }

  /**
   * Safely initialize the component. It checks if the section has already been initialized before calling the init method.
   * It is idempotent. It can be called multiple times without side effects.
   * After initialization, the section is marked as initialized with the data-js-initialized attribute.
   * @returns {boolean} true if the was not initialized yet and has been initialized, false otherwise.
   */
  _inherits(RecommendationComponent, _lm$Composant);
  return _createClass(RecommendationComponent, [{
    key: "safeInit",
    value: function safeInit() {
      if (this.constructor.sectionIsInitialized(this.section)) {
        SKIP_DEBUG || console.debug('Section', this.section.id, 'already initialized');
        return false;
      }
      SKIP_DEBUG || console.debug('Initializing section', this.section.id);
      this.constructor.setSectionInitialized(this.section);
      this.init();
      return true;
    }

    /**
     * Initialize the component by doing some side effect actions like adding event listeners, fetching data, updating DOM, etc.
     * Children class that override this method should call super.init() at the beginning of the method.
     */
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setDataMerchArbo();
      }, 2000);
    }

    /**
     * Call this static method once per page load, usually after dom ready event.
     * It initializes all html sections matching the selector and listen the lazy-loading event bus to
     * initialize the sections that might be lazy-loaded.
     */
  }, {
    key: "setDataMerchArbo",
    value:
    /**
     * Add the breadcrumb path to the "data-merch-arbo" attribute of any child element of the section, if exists.
     */
    function setDataMerchArbo() {
      var arbo = ['page_cat1_label', 'page_cat2_label', 'page_cat3_label', 'page_cat4_label'].filter(function (key) {
        return window.tc_vars[key] && window.tc_vars[key] !== '';
      }).map(function (key) {
        return window.tc_vars[key];
      });
      var childrenWithAttribute = this.section.querySelector('[data-merch-arbo]');
      if (childrenWithAttribute) {
        childrenWithAttribute.setAttribute('data-merch-arbo', arbo.join('/'));
      } else {
        console.warn('No element with attribute "data-merch-arbo" found in the section.');
      }
    }

    /**
     * Initialize the product sliders
     */
  }, {
    key: "initCarousel",
    value: function initCarousel() {
      var zoneId = this.section.getAttribute('data-zone-id');
      SKIP_DEBUG || console.log("init .carousel_".concat(zoneId));
      SKIP_DEBUG || console.log('Initializing product sliders ' + this.section.querySelectorAll('.js-carousel').length);
      this.section.querySelectorAll('.js-carousel').forEach(function (carousel) {
        // eslint-disable-next-line no-new
        new Carousel(carousel, {
          centerWhenNoButtons: true
        });
      });
    }

    /**
     * Add the event listener to the add to cart form of the item tiles.
     */
  }, {
    key: "handleItemTileAddToCartForm",
    value: function handleItemTileAddToCartForm() {
      var _this3 = this;
      this.section.querySelectorAll('.js-cross-sell-add-to-cart-form').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var data = getFormData(form);
          data.reflmAvailability = null;
          _this3.cartUpdate({
            listProducts: [data]
          });
        });
      });
    }
  }], [{
    key: "selector",
    get:
    /**
     * The CSS selector to match the html sections that will be initialized by this component.
     */
    function get() {
      throw new Error('You have to implement the method get selector');
    }

    /**
     * A pattern that matches fragment IDs from the recommendation, used for filtering fragmentLoaded events.
     */
  }, {
    key: "setupOnceDomIsReady",
    value: function setupOnceDomIsReady() {
      var _this4 = this;
      SKIP_DEBUG || console.debug('setup', this.selector);
      this.getSectionsNotAlreadyInitialized().forEach(function (section) {
        new _this4(section).safeInit();
      });
      if (this.lazyLoadable) {
        this.addLazyLoadingListener();
      }
    }

    /**
     * Return true if the section has already been initialized.
     * @param htmlSection
     * @returns {boolean}
     */
  }, {
    key: "sectionIsInitialized",
    value: function sectionIsInitialized(htmlSection) {
      return htmlSection.getAttribute('data-js-initialized') === 'true';
    }

    /**
     * Mark the section as initialized.
     * @param htmlSection
     */
  }, {
    key: "setSectionInitialized",
    value: function setSectionInitialized(htmlSection) {
      htmlSection.setAttribute('data-js-initialized', 'true');
    }

    /**
     * Return the sections that have not been initialized yet.
     */
  }, {
    key: "getSectionsNotAlreadyInitialized",
    value: function getSectionsNotAlreadyInitialized() {
      var _this5 = this;
      return Array.from(document.querySelectorAll(this.selector)).filter(function (section) {
        return !_this5.sectionIsInitialized(section);
      });
    }

    /**
     * Listen the lazy-loading event bus to be ready to initialize the sections that are lazy-loaded.
     */
  }, {
    key: "addLazyLoadingListener",
    value: function addLazyLoadingListener() {
      var _this6 = this;
      var lazyLoadingEventBus = window['lazy-loading-bus'];
      if (!lazyLoadingEventBus) {
        console.warn('Lazy loading event bus not found');
        return;
      }
      if (this.isLazyLoadingListenerAdded()) {
        console.warn('Lazy loading event bus already listened');
        return;
      }
      this.lazyLoadingListener = function (event) {
        return _this6.handleFragmentLoadedEvent(event);
      };
      lazyLoadingEventBus.on('fragmentLoaded', this.lazyLoadingListener);
    }

    /**
     * Remove the listener of the lazy-loading event bus.
     */
  }, {
    key: "removeLazyLoadingListener",
    value: function removeLazyLoadingListener() {
      var lazyLoadingEventBus = window['lazy-loading-bus'];
      if (!lazyLoadingEventBus) {
        console.warn('Lazy loading event bus not found');
        return;
      }
      if (!this.isLazyLoadingListenerAdded()) {
        console.warn('Lazy loading event bus not listened');
        return;
      }
      lazyLoadingEventBus.off('fragmentLoaded', this.lazyLoadingListener);
      this.lazyLoadingListener = undefined;
    }

    /**
     * Return true if the listener of the lazy-loading event bus has been added.
     * @returns {boolean}
     */
  }, {
    key: "isLazyLoadingListenerAdded",
    value: function isLazyLoadingListenerAdded() {
      return this.lazyLoadingListener !== undefined;
    }

    /**
     * The event handler for the lazy-loading event bus.
     * @param event containing the fragmentId and the htmlElements of the fragment that has been loaded.
     */
  }, {
    key: "handleFragmentLoadedEvent",
    value: function handleFragmentLoadedEvent(event) {
      var _this7 = this;
      var _event$detail = event.detail,
        fragmentId = _event$detail.fragmentId,
        htmlElements = _event$detail.htmlElements;
      SKIP_DEBUG || console.debug('Received fragmentLoaded event', fragmentId, htmlElements, this.lazyLoadableFragmentIds, this.selector);
      if (!this.recommendationFragmentIdRegExp.test(fragmentId)) {
        return;
      }
      var htmlSections = _toConsumableArray(htmlElements).filter(function (htmlElement) {
        return htmlElement.matches(_this7.selector);
      });
      if (htmlSections.length === 0) {
        SKIP_DEBUG || console.debug('No section matching', this.selector, 'found in the fragment', fragmentId, htmlElements);
        return;
      }
      var _iterator = _createForOfIteratorHelper(htmlSections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var htmlSection = _step.value;
          SKIP_DEBUG || console.debug('Lazy-loading section', htmlSection.id, 'for fragment', fragmentId);
          if (!this.sectionIsInitialized(htmlSection)) {
            new this(htmlSection).safeInit();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}(lm.Composant);
_defineProperty(RecommendationComponent, "recommendationFragmentIdRegExp", /com\.adeo\.website\.productrecommendation\..*/);
/**
 * If true, the component will listen the lazy-loading event bus to initialize the sections that are lazy-loaded.
 */
_defineProperty(RecommendationComponent, "lazyLoadable", false);